import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import DefaultQuoteProposalInfoPageStore, {
  DefaultQuoteProposalInfoPageStoreContext,
  useDefaultQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/default/pageStore';
import DefaultQuoteProposalInfoForm from 'components/quote/quote-proposal-info/Default';

const PageContent: React.FC = observer(() => {
  const { isActionLoading, flowDelegate, canCompleteStep, onComplete, getInitialData } =
    useDefaultQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <DefaultQuoteProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const DefaultQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new DefaultQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <DefaultQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DefaultQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default DefaultQuoteProposalInfoPage;
